import { useMemo } from 'react'

import { OrderDraftMutationStatusStatuses } from './OrderDraftMutationStatusEnum'
import { useOrderDraftMutationStatusContext } from './useOrderDraftMutationStatusContext'

export interface IOrderDraftMutationStatusCallbacks {
  onMutationStart: () => Nullable<number>
  onMutationComplete: (mutationSeq: Nullable<number> | undefined) => void
  onMutationError: (mutationSeq: Nullable<number> | undefined) => void
}

// Wires the order-draft mutation-status context to the generic lifecycle
// callbacks. Consumed at the feature-set level so feature slices never touch
// the context directly.
export const useOrderDraftMutationStatusCallbacks =
  (): IOrderDraftMutationStatusCallbacks => {
    const { setMutationStatus } = useOrderDraftMutationStatusContext()

    return useMemo(
      () => ({
        onMutationStart: () =>
          setMutationStatus(OrderDraftMutationStatusStatuses.UPDATING),
        onMutationComplete: (mutationSeq) =>
          setMutationStatus(
            OrderDraftMutationStatusStatuses.COMPLETED,
            mutationSeq ?? undefined
          ),
        onMutationError: (mutationSeq) =>
          setMutationStatus(
            OrderDraftMutationStatusStatuses.FAILED_TO_UPDATE,
            mutationSeq ?? undefined
          ),
      }),
      [setMutationStatus]
    )
  }
